import { AuthHttpError } from "@/api/geniBackend";

export const SOCIAL_ACCOUNT_EXISTS_MESSAGE =
  "У вас уже есть аккаунт. Войдите по номеру WhatsApp и паролю.";

export function isSocialAccountConflict(error: unknown): boolean {
  return error instanceof AuthHttpError && error.status === 409;
}

export function resolveSocialAuthErrorMessage(
  error: unknown,
  fallback: string,
): string {
  if (isSocialAccountConflict(error)) {
    return SOCIAL_ACCOUNT_EXISTS_MESSAGE;
  }
  if (error instanceof Error && error.message.trim()) {
    return error.message;
  }
  return fallback;
}
